import React from 'react';
import { fetchAPI } from './FetchAPIWrapper';
import Auth from '../Auth/Auth';

const inFieldFiltersWithPlusSeperator = ["Status", "Area", "SubArea", "Severity", "Topic", "RecordType", "Category", "ResolvedBy", "OwnerFullName", "TFSState", "JiraStatus"];
const salesforceKB = "Fetch_SF_KB_Combined";

const auth = new Auth();
let reCheckError;

function userLanguagePreference() {

  // An empty string is the equivalent of all languages
  if (localStorage.getItem('userPreferences')) {
    let userPreferences = JSON.parse(localStorage.getItem('userPreferences'));
    return userPreferences.HideFrench ? 'EN' : '';
  } else {
    return '';
  }
}

function targetSource(target) {
  if (target === 'All' || !target) {
    //Thunderstone takes an empty string as the All marker
    return '';
  } else {
    return target;
  }
}

function shouldUseSynonyms(searchQuery) {
  if (localStorage.getItem('Synonyms') === 'true') {
    return encodeURIComponent(synonyms(searchQuery));
  } else {
    return encodeURIComponent(searchQuery);
  }
}

function CopyLink() {
  /* Get the text field */
  var copyText = document.getElementById("foo");

  /* Select the text field */
  copyText.select();
  copyText.setSelectionRange(0, 99999); /*For mobile devices*/

  /* Copy the text inside the text field */
  document.execCommand("copy");
}

const HubLink = ({ closeToast }) => {
  return (
    <div>
      <p>Added to My Hub - (check your notifications)</p>
      <a href="https://hub.dayforcehcm.com" target="_blank" rel="noopener noreferrer">What is The Hub?</a>
    </div>
  );
};

const CerebroOpen = ({ closeToast }) => {
  return (
    <div>
      <h5>Cerebro already open</h5>
      <small>we have opened the case in quickview instead</small>
    </div>
  );
};

const removeBoldTags = (function () {
  var findStartBoldTags = /\/\/b/g;
  var findEndBoldTags = /\/\/#b/g;
  return function (quickview) {
    return quickview.replace(findStartBoldTags, '').replace(findEndBoldTags, '');
  };
})();

function cleanFetchXML(str) {
  // Before turning the XML thunderstone results into JSON we need to flatten any <b> and </b> tags 
  // We do this otherwise they will become their own obj's in json and makes it harder to turn back into HTML when displaying
  const escapedData = str.replaceAll('<b>', '//b').replaceAll('</b>', '//#b');
  const xml = (new window.DOMParser()).parseFromString(escapedData, 'text/xml');
  return xml2json(xml).ThunderstoneResults;
}

function xml2json(xml) {
  // Create the return object
  var obj = {};

  if (xml.nodeType === 1) {
    // element
    // do attributes
    if (xml.attributes.length > 0) {
      obj['@attributes'] = {};
      for (var j = 0; j < xml.attributes.length; j++) {
        var attribute = xml.attributes.item(j);
        obj['@attributes'][attribute.nodeName] = attribute.nodeValue;
      }
    }
  } else if (xml.nodeType === 3) {
    // text
    obj = xml.nodeValue;
  }

  // do children
  // If all text nodes inside, get concatenated text from them.
  var textNodes = [].slice.call(xml.childNodes).filter(function (node) {
    return node.nodeType === 3;
  });
  if (xml.hasChildNodes() && xml.childNodes.length === textNodes.length) {
    obj = [].slice.call(xml.childNodes).reduce(function (text, node) {
      return text + node.nodeValue;
    }, '');
  } else if (xml.hasChildNodes()) {
    for (var i = 0; i < xml.childNodes.length; i++) {
      var item = xml.childNodes.item(i);
      var nodeName = item.nodeName.replace(':', '');
      if (typeof obj[nodeName] === 'undefined') {
        obj[nodeName] = xml2json(item);
      } else {
        if (typeof obj[nodeName].push === 'undefined') {
          var old = obj[nodeName];
          obj[nodeName] = [];
          obj[nodeName].push(old);
        }
        obj[nodeName].push(xml2json(item));
      }
    }
  }
  return obj;
}

function synonyms(str) {
  let strMatch = str.match(/\w+|"[^"]+"/g);
  for (var i = 0; i < strMatch.length; i++) {
    strMatch[i] = strMatch[i].replaceAll(new RegExp('" ', 'g'), '"').replaceAll(new RegExp(' "', 'g'), '"');
    if (strMatch[i].indexOf('"') === -1) {
      strMatch[i] = '~' + strMatch[i];
    }
  }
  let trimStr = strMatch.join(" ").trim();

  return trimStr;
}

function parseJwt(token) {
  if (token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
  }


}

function targetColor(target) {
  switch (target) {

    case "D365": return "#000000";

    case "Y_Drive": return "#c1b13c";

    case salesforceKB: return "#b902b9";

    case "TFS": return "#790000";

    default: return "#618cce";
  }
}

function targetName(BackendProfile) {
  let BackendProfileName = (Array.isArray(BackendProfile) ? BackendProfile[0] : BackendProfile);
  if (BackendProfileName === salesforceKB) {
    BackendProfileName = "Salesforce KB";
  } else {
    BackendProfileName = BackendProfileName;
  }

  return BackendProfileName;
}

function targetIcon(BackendProfile) {
  let Icon;
  let BackendProfileName = (Array.isArray(BackendProfile) ? BackendProfile[0] : BackendProfile);

  switch (BackendProfileName) {
    case "D365": Icon = "365";
      break;

    case "D365_Test": Icon = "365";
      break;

    case "Y_Drive": Icon = "Y";
      break;

    case "TFS": Icon = "TFS";
      break;

    case "Communities": Icon = "CM";
      break;

    case "Discussions": Icon = "CM";
      break;

    default: Icon = "";
      break;
  }
  return Icon;
}

async function LogSearch(self, mainSearch, target, url, NoResults, smartPanelDisplayed, IsAdvancedFiltered) {
  let slightEncode = encodeURI(url).replaceAll("25", "").replaceAll("rorder=0", "rorder=250");
  let jwt = parseJwt(localStorage.getItem("msal.idtoken"));
  let accessToken = await auth.getToken();
  var resources = performance.getEntriesByType("resource");
  for (var i = resources.length - 1; i >= 0; i--) {

    if (resources[i].name === encodeURI(url) || encodeURI(resources[i].name) === encodeURI(url) || resources[i].name === url || encodeURI(resources[i].name) === url || slightEncode === resources[i].name) {
      var responseTime = (resources[i].duration / 1000).toFixed(2);
      //Adding search to Fetch DB
      fetch(`/api/usersearch`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "loggedinClient": jwt.oid,
          'Authorization': "Bearer " + accessToken,
          withCredentials: true,
          crossDomain: true,
        },
        body: JSON.stringify({ "searchQuery": mainSearch, "target": target, "searchURL": url, "advancedFiltered": IsAdvancedFiltered, "responseTime": responseTime, 'NoResults': NoResults, 'smartPanelDisplayed': smartPanelDisplayed })
      }).then(response => {
        if (response.status !== 200) {
          let payload = [{
            status: response.status,
            rawmsg: response.statusText,
            cleanmsg: response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
            location: response.url,
            timestamp: Date.now(),
          }];
          throw {
            payload: payload,
            error: new Error()
          };
        }
        return response.json();
      }).then(success => {
        self.setState({
          currentURL: url
        });
      }).catch((error) => {
        console.error('Error:', error);
        window.apiError(error);
      });
      break;
    }
  }
}

function boldWords(str) {
  let htmlCleanerRegEx = /<[^>]*>/g;
  str = str.replace(htmlCleanerRegEx, ' ');
  str = str.replace(new RegExp('//b', 'g'), "<b>").replace(new RegExp('//#b', 'g'), "</b>");
  return str;
}

function cleanWords(str) {
  let htmlCleanerRegEx = /<[^>]*>/g;
  str = str.replace(htmlCleanerRegEx, ' ');
  str = str.replace(new RegExp('//b', 'g'), "").replace(new RegExp('//#b', 'g'), "");
  return str;
}

function cleanLinks(items, isQuickView) {
  try {
    let target = (Array.isArray(items.BackendProfile) ? items.BackendProfile[0] : items.BackendProfile);

    let url;
    switch (target) {
      case salesforceKB:
      case "Discussions":
      case "CommunitySalesforcePublic":
      case "CommunitySalesforcePrivate":
      case "CommunitySalesforcePublicUAT":
        url = items.Url;
        break;

      case "D365": url = items.uQuickViewURL;
        break;

      default: url = items.uURL;
    }

    if ((localStorage.getItem("quickview") && localStorage.getItem("quickview") === "true") && (isQuickView !== false)) {
      let type;
      let quickviewurl;

      switch (target) {

        case "D365": type = "D365"; quickviewurl = removeBoldTags(items.uQuickViewURL).split("/").pop();
          break;        

        case "Discussions": type = "Discussions"; quickviewurl = removeBoldTags(items.Url).split("/").pop();
          break;

        case "TFS": type = "TFS"; quickviewurl = removeBoldTags(items.uURL).split("=").pop();
          break;       

        default: type = null; quickviewurl = null;
      }

      if (type !== null && items.Url.indexOf("D365NoteAttachmentDownload") < 0) {
        url = type + "/QuickView/" + quickviewurl;
      }
    }

    //Setting Jira QuickView url by Default
    if(target === "Jira" && isQuickView === undefined){
      url = "Jira/QuickView/" + removeBoldTags(items.uURL);
    }

    if (Object.entries(url).length === 0) {
      url = null;
    } else {
      let htmlCleanerRegEx = /<[^>]*>/g;
      url = url.replace(htmlCleanerRegEx, ' ');
      url = url.replace(new RegExp('//b', 'g'), "").replace(new RegExp('//#b', 'g'), "");
    }
    return url;
  } catch (err) {
    console.log(err);
  }
}

function clickTracker(linkData) {
  fetchAPI.post('/api/clicktracker', {
    body: linkData
  })
    .then(() => {
    }).catch(error => {
      window.apiError(error);
    });
}

function cleanQuickView(quickView) {
  let cleanStr = "";
  let url;
  if (quickView.indexOf(" ") > -1) {
    cleanStr = (quickView).toString().substr(0, (quickView).toString().indexOf(" "));
  } else {
    cleanStr = quickView;
  }
  let htmlCleanerRegEx = /<[^>]*>/g;

  url = cleanStr.replace(htmlCleanerRegEx, ' ');
  url = url.replace(new RegExp('//b', 'g'), "").replace(new RegExp('//#b', 'g'), "");

  return url;
}

function quickViewLink(items) {
  try {
    let target = (Array.isArray(items.BackendProfile) ? items.BackendProfile[0] : items.BackendProfile);
    let type;
    let quickviewurl;
    let url;
    switch (target) {

      //These TARGETS have QuickView Links
      case "D365": type = "D365"; quickviewurl = items.uQuickViewURL.split("/").pop();
        break;

      case "D365_Test": type = "D365"; quickviewurl = items.uQuickViewURL.split("/").pop();
        break;

      case "Discussions": type = "Discussions"; quickviewurl = items.Url.split("/").pop();
        break;

      case "TFS": type = "TFS"; quickviewurl = items.uURL.split("=").pop();
        break;

      case "Jira": type = "Jira"; quickviewurl = items.uURL.split("=").pop();
        break;

      //These Do Not have quicklinks        
      case "Y_Drive": type = null; url = items.Url;
        break;

      default: type = null; quickviewurl = null;

    }

    if (type !== null && items.Url.indexOf("D365NoteAttachmentDownload") < 0) {
      url = type + "/QuickView/" + quickviewurl;
    }

    if (Object.entries(url).length === 0) {
      url = null;
    } else {
      let htmlCleanerRegEx = /<[^>]*>/g;
      url = url.replace(htmlCleanerRegEx, ' ');
      url = url.replace(new RegExp('//b', 'g'), "").replace(new RegExp('//#b', 'g'), "");
    }
    return url;
  } catch (err) {
    console.log(err);
  }
}

function decodeHTMLEntities(text) {
  var textArea = document.createElement('textarea');
  textArea.innerHTML = text;

  return textArea.value;
}

function dontShow() {
  localStorage.setItem("feedbackNoShow", "true");
  document.getElementsByClassName("general-feedback")[0].classList.remove("active");
  document.getElementsByClassName("general-feedback")[0].classList.add("d-none");
}

function criticalErrors(self) {

  fetch(`${process.env.PUBLIC_URL}/config.json`)
    .then(response => {
      if (response.status !== 200) {
        let payload = [{
          status: response.status,
          rawmsg: response.statusText,
          cleanmsg: response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
          location: response.url,
          timestamp: Date.now(),
        }];
        throw {
          payload: payload,
          error: new Error()
        };
      }
      return response.json();
    }).then(data => {
      let config = data.config;
      if (config.CriticalError !== null) {
        let error = {
          Title: "We are currently experiencing some issues:",
          Details: config.CriticalError
        };
        self.setState({
          ErrorNotification: [error]
        });
        if (!reCheckError) {
          //clearInterval(reCheckError);
          killErrorRecheck();
          reCheckError = setInterval(function () {
            criticalErrors(self);
          }, 20 * 60 * 1000);
        }
        return true;
      } else {
        self.setState({
          ErrorNotification: []
        });
        //clearInterval(reCheckError)
        killErrorRecheck();
        return false;
      }
    }).catch((error) => {
      window.apiError(error);
      //clearInterval(reCheckError)
      killErrorRecheck();
    });
}

function killErrorRecheck() {
  var killId = setTimeout(function () {
    for (var i = killId; i > 0; i--) {
      clearInterval(i);
    }
  }, 3000);
  clearInterval(reCheckError);
}


function infieldSearchCreator(filterType, filterValue) {
  if (!filterValue) {
    return '';
  }

  if (inFieldFiltersWithPlusSeperator.includes(filterType)) {
    filterValue = filterValue.replace(/ /g, '+');
  }

  return `+${infieldString(filterType, filterValue)}`;
}

const inFieldStringsByFilterType = Object.freeze({
  Area: (filterValue) => `infield:enc:Area(${filterValue})`,
  SubArea: (filterValue) => `infield:enc:SubArea(${filterValue})`,
  Status: (filterValue) => `infield:enc:Ticket_Status(${filterValue})`,
  WorkItemType: (filterValue) => `infield:enc:Work_Item_Type(${filterValue})`,
  IssueType: (filterValue) => `infield:enc:IssueType(${filterValue})`,
  TFSState: (filterValue) => `infield:enc:State(${filterValue})`,
  JiraStatus: (filterValue) => `infield:enc:Status(${filterValue})`,
  Severity: (filterValue) => `infield:enc:Severity(${filterValue})`,
  Topic: (filterValue) => `infield:enc:Topics(${filterValue})`,
  RecordType: (filterValue) => `infield:enc:RecordType(${filterValue})`,
  Category: (filterValue) => `infield:enc:Category(${filterValue})`,
  Namespace: (filterValue) => `infield:Namespace=${filterValue}`,
  ResolvedBy: (filterValue) => `infield:enc:ResolvedBy=${filterValue}`,
  OwnerFullName: (filterValue) => `infield:enc:OwnerFullName=${filterValue}`,
  ResolveddateFrom: (filterValue) => `infield:Resolved_Date>=${filterValue}`,
  ResolveddateTo: (filterValue) => `infield:Resolved_Date<=${filterValue}`
});

function infieldString(filterType, filterValue) {
  const infield = inFieldStringsByFilterType[filterType](filterValue);
  return encodeURIComponent(infield);
}

function removeFlattenedThunderstoneHTMLTags(str) {
  return str.replaceAll('//b', '').replaceAll('//#b', '');
}

export {
  userLanguagePreference, targetSource, shouldUseSynonyms, CopyLink, HubLink, CerebroOpen, xml2json, cleanFetchXML, synonyms, parseJwt,
  targetColor, targetName, targetIcon, LogSearch, boldWords, cleanWords, cleanLinks, clickTracker, cleanQuickView,
  decodeHTMLEntities, dontShow, criticalErrors, quickViewLink, infieldSearchCreator, removeFlattenedThunderstoneHTMLTags, removeBoldTags
};